<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        color="primary"
        v-on="on"
      >
        <v-icon>
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Probation"
      text="Edit Probation"
      class="mb-0"
      :loading="loading"
    >
      <form v-if="dialog && !loading">
        <v-container>
          <v-row no-gutters>
            <v-col cols="12">
              <v-text-field
                disabled
                :value="localProbation.employee.person.name"
                outlined
                label="Employee"
              />
            </v-col> 

            <v-col cols="12">
              <v-menu
                v-model="probationStartDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="probationStartDateDisplay"
                    v-validate="'required'"
                    label="Probation Start Date"
                    outlined
                    :error-messages="errors.collect('probationStartDateDisplay')"
                    data-vv-name="probationStartDateDisplay"  
                    data-vv-as="probation start date"      
                    readonly
                    class="fix-date-picker-outline-overlap"
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="localProbation.start_date"
                  @input="probationStartDateMenu = false"
                />
              </v-menu>
            </v-col> 

            <v-col cols="12">
              <v-menu
                v-model="probationEndDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="probationEndDateDisplay"
                    v-validate="'required'"
                    label="Probation End Date"
                    outlined
                    :error-messages="errors.collect('probationEndDateDisplay')"
                    data-vv-name="probationEndDateDisplay"  
                    data-vv-as="probation end date"      
                    readonly
                    class="fix-date-picker-outline-overlap"
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="localProbation.end_date"
                  @input="probationEndDateMenu = false"
                />
              </v-menu>
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions v-if="!loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10" 
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary" 
          class="white--text px-10"         
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      probation: {
        type: Object,
        default: null,
      },  
    },
    data () {
      return {
        dialog: null,
        progressing: false,
        localProbation: null,
        probationStartDateMenu: false,
        probationEndDateMenu: false,
        loading: false,
      }
    },
    computed: {
      probationStartDateDisplay () {
        return this.localProbation.start_date ? this.$moment(this.localProbation.start_date, 'YYYY-MM-DD').format('D MMM YYYY') : ''
      },
      probationEndDateDisplay () {
        return this.localProbation.end_date ? this.$moment(this.localProbation.end_date, 'YYYY-MM-DD').format('D MMM YYYY') : ''
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) return this.$resetData()

        this.loading = true

        this.localProbation = { ...this.probation }
      
        this.loading = false
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.employeeProbations().update(this.probation.id, this.prepareFormData())
              .then(response => {
                if (response.status >= 200 && response.status < 300) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.dialog = false
                }
              })
              .catch(() => {})
              .then(() => {
                this.progressing = false
              })
          })
      },

      prepareFormData () {
        return {
          start_date: this.localProbation.start_date,
          end_date: this.localProbation.end_date,
        }
      },
    },
  }
</script>

<style scoped>
.fix-date-picker-outline-overlap >>> label{
  background: white;
  padding-right:10px
}
</style>
